export default "__VITE_ASSET__c0d9e053__"